import type { ReactNode } from "react";

import { useIsDesktop } from "@/hooks/use-media-query";

/**
 * Render gates for the two layouts, for JSX built outside a component (a module's `detailView`).
 * They MOUNT one branch instead of hiding the other with `hidden lg:flex`: a hidden desktop
 * leaderboard is still rendered, measured and styled on every phone commit — and that work
 * landed in the same frames as the tab pill's animation.
 */
export const AtLg = ({ children }: { children: ReactNode }) =>
  useIsDesktop() ? <>{children}</> : null;

export const BelowLg = ({ children }: { children: ReactNode }) =>
  useIsDesktop() ? null : <>{children}</>;
